// Utils
function addDotToExt(ext: string) {
  if (ext[0] === '.') return ext;
  return `.${ext}`;
}

export function getAcceptedFileTypes(types: string[]) {
  return types.map((item) => addDotToExt(item)).join(', ');
}

export function getFileTypesMsg(fileTypes: string[]): string {
  if (!Array.isArray(fileTypes) || fileTypes.length === 0) {
    return '';
  } else if (fileTypes.length === 1) {
    return fileTypes[0].toUpperCase();
  } else {
    const lastFileType = fileTypes[fileTypes.length - 1].toUpperCase();
    const formattedFileTypes = fileTypes
      .slice(0, -1)
      .map((fileType) => fileType.toUpperCase())
      .join(', ');
    return `${formattedFileTypes} or ${lastFileType}`;
  }
}
